import React, { useState } from 'react';
import { MFAVerify } from '../MFAVerify';
import { MfaSetupTotp } from './MfaSetupTotp';
import { MfaSetupEmailForm } from './MfaSetupEmailForm';
import { Button } from '@/shared/components/ui/button/Button';
import { useAuth } from '../../hooks/useAuth';

export const MFASetup: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'totp' | 'email'>('totp');
    const [showVerify, setShowVerify] = useState(false);
    const { logoutAndRedirect } = useAuth();

    if (showVerify) {
        return <MFAVerify />;
    }

    return (
        <div className="flex flex-col flex-1">
            <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
                <div>
                    <div className="mb-5 sm:mb-8 space-y-3">
                        <h1 className="mb-2 font-semibold text-mp-foreground text-title-sm sm:text-title-md">
                            MFA Setup
                        </h1>
                        <p className="text-sm text-mp-muted">
                            You need to setup Multi-Factor Authentication (MFA) with your account in
                            order to finalise your security options and login.
                        </p>
                        <p className="text-sm text-mp-muted">
                            Please chose your preferred method below, you will be able to change
                            this later if you wish.
                        </p>
                    </div>
                </div>
                <div className="flex flex-row">
                    <Button
                        onClick={() => setActiveTab('totp')}
                        className="w-1/2 p-2"
                        variant={`${activeTab === 'totp' ? 'primary' : 'secondary'}`}
                        rounded={false}
                    >
                        Authenticator App
                    </Button>
                    <Button
                        onClick={() => setActiveTab('email')}
                        className="w-1/2 p-2"
                        variant={`${activeTab === 'email' ? 'primary' : 'secondary'}`}
                        rounded={false}
                    >
                        Email
                    </Button>
                </div>
                {activeTab === 'totp' && (
                    <MfaSetupTotp
                        moveNext={() => {
                            setShowVerify(true);
                        }}
                    />
                )}
                {activeTab === 'email' && (
                    <MfaSetupEmailForm
                        moveNext={() => {
                            setShowVerify(true);
                        }}
                    />
                )}

                <div className="mt-6 text-center text-sm text-mp-muted">
                    <button
                        type="button"
                        onClick={logoutAndRedirect}
                        className="font-medium text-mp-link"
                    >
                        Back to login
                    </button>
                </div>
            </div>
        </div>
    );
};
